import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const FillLinkedin = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 8 8"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.11113 0C7.34687 0 7.57293 0.0936534 7.73967 0.260347C7.90633 0.427047 8 0.65314 8 0.888887V7.11113C8 7.34687 7.90633 7.57293 7.73967 7.73967C7.57293 7.90633 7.34687 8 7.11113 8H0.888887C0.65314 8 0.427047 7.90633 0.260347 7.73967C0.0936534 7.57293 0 7.34687 0 7.11113V0.888887C0 0.65314 0.0936534 0.427047 0.260347 0.260347C0.427047 0.0936534 0.65314 0 0.888887 0H7.11113ZM6.88887 6.88887V4.53333C6.88887 4.14907 6.73627 3.78053 6.46453 3.50881C6.1928 3.23709 5.82427 3.08445 5.44 3.08445C5.06222 3.08445 4.62222 3.31555 4.40889 3.66222V3.16889H3.16889V6.88887H4.40889V4.69778C4.40889 4.35555 4.68445 4.07555 5.02667 4.07555C5.19169 4.07555 5.34993 4.14111 5.46667 4.2578C5.58333 4.37449 5.64887 4.53275 5.64887 4.69778V6.88887H6.88887ZM1.72445 2.47111C1.92247 2.47111 2.11239 2.39245 2.25242 2.25242C2.39245 2.11239 2.47111 1.92247 2.47111 1.72445C2.47111 1.31111 2.13778 0.973333 1.72445 0.973333C1.52524 0.973333 1.33419 1.05247 1.19333 1.19333C1.05247 1.33419 0.973333 1.52524 0.973333 1.72445C0.973333 2.13778 1.31111 2.47111 1.72445 2.47111ZM2.34222 6.88887V3.16889H1.11111V6.88887H2.34222Z"
      fill="currentColor"
    />
  </svg>
)

export default withDefaultStyles(FillLinkedin)
